export default __webpack_public_path__ + "static/snowflake-logo-7cfc1328c2569157d8f474c3d8e97db4.png";